import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import wordLogo from '../../assets/persnormal-word-logo.svg';
import './Footer.css';

const Footer = () => {
    const {t} = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-inner container">
                <div className="footer-brand">
                    <Link to="/" aria-label={t('company.logo_alt')}>
                        <img src={wordLogo} alt=""/>
                    </Link>
                    <p>{t('footer.brand_line')}</p>
                </div>

                <div className="footer-links">
                    <div>
                        <strong>{t('footer.col.apps')}</strong>
                        <Link to="/eat-slowly">{t('eat_slowly_name')}</Link>
                        <Link to="/spend-gently">{t('spend_gently_name')}</Link>
                        <Link to="/fridge-organizer">{t('fridge_organizer_name')}</Link>
                    </div>
                    <div>
                        <strong>{t('footer.col.company')}</strong>
                        <Link to="/">{t('nav.home')}</Link>
                        <Link to="/contact">{t('nav.contact')}</Link>
                    </div>
                    <div>
                        <strong>{t('footer.privacy')}</strong>
                        <Link to="/privacy/eatSlowly">{t('eat_slowly_name')}</Link>
                        <Link to="/privacy/spendGently">{t('spend_gently_name')}</Link>
                        <Link to="/privacy/fridgeOrganizer">{t('fridge_organizer_name')}</Link>
                    </div>
                </div>
            </div>

            <div className="footer-bottom container">
                <p>
                    <span>{t('footer.companyName')}</span>
                    <span>{t('footer.businessNumberLabel')} {t('footer.businessNumber')}</span>
                    <a href="mailto:develop@persnormal.com">develop@persnormal.com</a>
                </p>
                <p>© {currentYear} Persnormal. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
